import React from "react";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faShareNodes} from "@fortawesome/free-solid-svg-icons";

import Help from "../Help.js";

const FieldLinkHelp = ({shared = false, linkedAcrossStates = false}) => (
  <>
    {shared && (
      <Help icon={<FontAwesomeIcon icon={faShareNodes} />}>
        This field is shared accross multiple checksheets.
      </Help>
    )}
    {!shared && linkedAcrossStates && (
      <Help icon={<FontAwesomeIcon icon={faShareNodes} />}>
        This field is on both checksheet states. Responses submitted under either variant are
        associated with the same field.
      </Help>
    )}
  </>
);

FieldLinkHelp.propTypes = {
  shared: PropTypes.bool,
  linkedAcrossStates: PropTypes.bool
};

export default FieldLinkHelp;
